var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { UiButton } from '@claims-ia/design-system';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { translateChoices } from '@shared/choice';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import { INSURER_CONFIG } from '@shared/insurer';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
import FileCollectionUpload from '@declaration/components/upload/FileCollectionUpload.vue';
import { ClaimFileType } from '@shared/types/file';
const claim = namespace('claim');
const qualification = namespace('qualification');
let WaterLeakageCauseLocalizedPlumberIntervenedQuestion = class WaterLeakageCauseLocalizedPlumberIntervenedQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.hasPlumberIntervened = null;
        this.plumberInvoiceFileCollection = null;
        this.jointReportFileCollection = null;
        this.plumberIntervenedStep = 0;
        this.ClaimFileType = ClaimFileType;
    }
    created() {
        var _a, _b, _c, _d;
        this.hasPlumberIntervened = (_b = (_a = this.waterDamageQualification) === null || _a === void 0 ? void 0 : _a.hasPlumberIntervened) !== null && _b !== void 0 ? _b : null;
        this.plumberInvoiceFileCollection = (_c = this.waterDamageQualification.plumberInvoice) !== null && _c !== void 0 ? _c : null;
        this.jointReportFileCollection = (_d = this.waterDamageQualification.jointReport) !== null && _d !== void 0 ? _d : null;
    }
    get plumberIntervenedPayload() {
        const payload = { step: this.step, qualificationPayload: {} };
        if (this.plumberInvoiceFileCollection) {
            payload.qualificationPayload.plumberInvoice = this.plumberInvoiceFileCollection;
        }
        if (this.jointReportFileCollection) {
            payload.qualificationPayload.jointReport = this.jointReportFileCollection;
        }
        if (this.hasPlumberIntervened !== null) {
            payload.qualificationPayload.hasPlumberIntervened = this.hasPlumberIntervened;
        }
        return payload;
    }
    get panelTitle() {
        return this.$t('step.qualification/degat-des-eaux/fuite-localisee/plombier-intervenu.panel-title');
    }
    get sidebarTitle() {
        const key = 'step.qualification/degat-des-eaux/fuite-localisee/plombier-intervenu.question-sidebar_title';
        return this.$te(key) ? this.$t(key) : this.panelTitle;
    }
    get choices() {
        return translateChoices(YES_OR_NO_CHOICES, this.$i18n.tc.bind(this.$i18n));
    }
    get answer() {
        if (this.waterDamageQualification.hasPlumberIntervened === null) {
            return null;
        }
        const key = this.waterDamageQualification.hasPlumberIntervened ? 'yes' : 'no';
        return this.$tc(`step.qualification/degat-des-eaux/fuite-localisee/plombier-intervenu.answers.${key}`);
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink);
    }
    get showHelpLink() {
        var _a, _b;
        if (this.hideHelpLink &&
            ((_b = (_a = INSURER_CONFIG.declaration.pages) === null || _a === void 0 ? void 0 : _a.waterLeakageCauseLocalizedPlumberIntervened) === null || _b === void 0 ? void 0 : _b.showHelpLink) === false) {
            return false;
        }
        return true;
    }
    get shouldAskForJointReport() {
        var _a, _b, _c;
        return ((_c = (_b = (_a = INSURER_CONFIG.declaration.pages) === null || _a === void 0 ? void 0 : _a.waterLeakageCauseLocalizedPlumberIntervened) === null || _b === void 0 ? void 0 : _b.askForJointReport) !== null && _c !== void 0 ? _c : false);
    }
    get shouldAskForPlumberInvoice() {
        var _a, _b, _c;
        return ((_c = (_b = (_a = INSURER_CONFIG.declaration.pages) === null || _a === void 0 ? void 0 : _a.waterLeakageCauseLocalizedPlumberIntervened) === null || _b === void 0 ? void 0 : _b.askForPlumberInvoice) !== null && _c !== void 0 ? _c : false);
    }
    get showJointReportUpload() {
        return this.hasPlumberIntervened !== null && this.shouldAskForJointReport;
    }
    get showPlumberInvoiceUpload() {
        return this.hasPlumberIntervened && this.shouldAskForPlumberInvoice;
    }
    get showNextButton() {
        return (this.hasPlumberIntervened !== null &&
            (this.showPlumberInvoiceUpload || this.showJointReportUpload));
    }
    get validationLabel() {
        return this.$tc('claim.damage.joint-report.next-step');
    }
    get isLoadingYesNoAnswser() {
        if (this.showPlumberInvoiceUpload || this.showJointReportUpload) {
            return false;
        }
        return this.isUpdatingClaim;
    }
    onHasPlumberIntervenedUpdate(hasPlumberIntervened) {
        this.hasPlumberIntervened = hasPlumberIntervened;
        if (!this.shouldAskForPlumberInvoice && !this.shouldAskForJointReport)
            this.validate();
    }
    onPlumberInvoiceCollectionUpdate(plumberInvoice) {
        this.plumberInvoiceFileCollection = plumberInvoice;
    }
    onJointReportFileCollectionUpdate(jointReport) {
        this.jointReportFileCollection = jointReport;
    }
    async validate() {
        await this.updateAndSaveWaterDamageQualification({ ...this.plumberIntervenedPayload });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion.prototype, "waterDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion.prototype, "updateAndSaveWaterDamageQualification", void 0);
WaterLeakageCauseLocalizedPlumberIntervenedQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel, FileCollectionUpload, UiButton },
        props: QuestionProps,
    })
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion);
export default WaterLeakageCauseLocalizedPlumberIntervenedQuestion;
